export default __webpack_public_path__ + "static/media/welcome-banner.b0d3f311.png";